/* @flow */
import * as React from 'react';

import capitalize from 'utils/capitalize';
import MediaObject from 'components/MediaObject';
import TextBadge from 'components/TextBadge';
import TitleHeader from 'components/TitleHeader';
import Timestamp from 'components/Timestamp';
import ZopimButton from 'support/components/ZopimButton';

function statusColor(status: string) {
  if (status === 'on hold') {
    return 'lava';
  }
  if (status === 'pending') {
    return 'flame';
  }
  return 'thunder';
}

function AdminSchoolSisDashboardStatus(props: { date: ?Date, status: string }) {
  const { date, status } = props;
  const color = statusColor(status);

  return (
    <TextBadge textColor={color} textSize="xxxxsmall">
      {capitalize(status)}
      {date && (
        <span>
          : Last sync <Timestamp format="long" date={date} />
        </span>
      )}
    </TextBadge>
  );
}

type Props = {
  subtext: string | React.Node,
  lastSyncTimestamp?: number,
  status: string,
};

export default function AdminSchoolSisSyncHeader({ subtext, lastSyncTimestamp, status }: Props) {
  return (
    <TitleHeader
      title={
        <React.Fragment>
          <MediaObject center figure="right" gutter="xsmall" inline>
            <span>SIS sync</span>
            <AdminSchoolSisDashboardStatus
              status={status}
              date={lastSyncTimestamp ? new Date(lastSyncTimestamp * 1000) : null}
            />
          </MediaObject>
        </React.Fragment>
      }
      subtext={subtext}
      action={<ZopimButton level="secondary" />}
      actionPlacement="right"
      className="AdminSchoolSisSyncHeader"
    />
  );
}
